import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Header.css';

const Header = ({ onMenuToggle, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    navigate('/login');
  };

  return (
    <header className="dashboard-header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onMenuToggle}>
          <span>☰</span>
        </button>
        <h1>Admin Panel</h1>
      </div>
      <div className="header-right">
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header; 